import React from 'react';
import { Row, Col } from '@thd-olt-component-react/grid';
import { func, oneOf, string } from 'prop-types';
import classNames from 'classnames';
import * as analytics from '../analytics/analytics';
import '../../AugmentedReality.style.scss';

const ARContent = ({ assetLink, channel, onClick }) => {
  const arClassName = classNames('augmented-reality__wrapper', {
    'augmented-reality__wrapper--desktop': channel !== 'mobile'
  });

  const handleOnClick = (clickEvent) => {
    analytics.track(clickEvent);
    if (onClick) {
      clickEvent.preventDefault();
      onClick(assetLink);
    }
  };

  const buttonLink = (
    <button className="augmented-reality__button" onClick={handleOnClick} type="button">
      <span className="augmented-reality__image">
        <img src="https://assets.homedepot-static.com/images/v1/AR-icon.svg" alt="" />
      </span>
      <span className="augmented-reality-button__prompt">
        <span>See it in your home with</span>
        <span className="augmented-reality__wrapper--view"> 3D Augmented Reality</span>
      </span>
      <span className="augmented-reality__wrap--arrow" />

    </button>
  );

  return onClick ? buttonLink : (
    <a
      href={assetLink}
      rel="ar"
      className="augmented-reality__link"
      onClick={handleOnClick}
    >
      <img src="" alt="" aria-hidden="true" />
      <Row className={arClassName}>
        <Col>
          <span className="augmented-reality__image">
            <img src="https://assets.homedepot-static.com/images/v1/AR-icon.svg" alt="" />
          </span>
        </Col>
        <Col className="augmented-reality__text">
          <span>
            <span>See it in your home with</span>
            <div className="augmented-reality__wrapper--view"> 3D Augmented Reality</div>
          </span>
        </Col>
        <Col className="augmented-reality__wrap">
          <span className="augmented-reality__wrap--arrow" />
        </Col>
      </Row>
    </a>
  );
};

ARContent.propTypes = {
  assetLink: string,
  channel: oneOf(['desktop', 'mobile']),
  onClick: func
};

ARContent.defaultProps = {
  assetLink: '',
  channel: 'desktop',
  onClick: null
};
export { ARContent };
